module.exports = __webpack_public_path__ + "images/search-e28927.svg";